import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@com/core/common/translations/i18n';

type TProps = {
    checked?: boolean;
    message: string;
    toggleFoupon?: (checked: boolean) => void;
    position?: 'above' | 'below';
};

const FouponItemLevel = ({ checked, message, position = 'below', toggleFoupon }: TProps): JSX.Element | null => {
    const { t } = useTranslation('common');
    // const [showHelper, setShowHelper] = useState(false);

    return (
        <Container className={position}>
            <ToggleRow>
                <div className="tagContainer">
                    <div className="start">
                        <img src="/foupon-item-level-tag-edge.svg" alt="" />
                    </div>
                    <span className="tag">{t('coupon')}</span>
                    <div className="end">
                        <img src="/foupon-item-level-tag-edge.svg" alt="" />
                    </div>
                </div>
                <button
                    className="couponToggle"
                    type="button"
                    onClick={() => toggleFoupon(!checked)}
                    disabled={!toggleFoupon}>
                    {toggleFoupon && <span className={`fauxCheckbox${checked ? ' checked' : ''}`} />}
                    <span className="message">{message}</span>
                </button>
                {/* <button className="helper" type="button" onClick={() => setShowHelper(!showHelper)}>
                    <img src={MARKETPLACE_CONFIG.assets.icons.help} alt="help" />
                </button> */}
                <img src="/foupon-item-level-ridge.svg" alt="" className="ridge start" />
                <img src="/foupon-item-level-ridge.svg" alt="" className="ridge end" />
            </ToggleRow>
            {/* <Collapsible trigger="" open={showHelper}>
                <HelperNotes>Hey Teddy and Parker - why you sleeping</HelperNotes>
            </Collapsible> */}
        </Container>
    );
};

const Container = styled.div`
    position: relative;

    &.above {
        border-bottom: 2px dashed ${({ theme }): string => theme.colors.borderDark};

        .ridge {
            bottom: -9px;
        }
    }

    &.below {
        border-top: 2px dashed ${({ theme }): string => theme.colors.borderDark};

        .ridge {
            top: -9px;
        }
    }

    .ridge {
        height: 16px;
        position: absolute;

        &.start {
            ${({ theme: { left } }): string => `${left}: -16px`};
            ${({ theme }): string => (theme.isRTL ? `transform: rotate(180deg);` : ``)}
        }

        &.end {
            ${({ theme: { right } }): string => `${right}: -16px`};
            ${({ theme }): string => (theme.isRTL ? `` : `transform: rotate(180deg);`)}
        }
    }
`;

const ToggleRow = styled.div`
    padding: 14px 0 16px;
    display: flex;
    align-items: center;

    .tagContainer {
        display: flex;
        align-items: center;
        ${({ theme: { right } }): string => `margin-${right}: 16px`};
        height: 20px;

        > div {
            &.start {
                ${({ theme }): string => (theme.isRTL ? `transform: rotate(180deg);` : ``)}
            }

            &.end {
                ${({ theme }): string => (theme.isRTL ? `` : `transform: rotate(180deg);`)}
            }
        }

        img {
            height: 100%;
            width: auto;
            max-width: none;
        }

        .tag {
            background-color: ${({ theme }): string => theme.colors.generalPositive};
            color: ${({ theme }): string => theme.colors.bodyAlt};
            text-transform: uppercase;
            font-size: 0.75rem;
            font-weight: bold;
            vertical-align: middle;
            padding: 3px 7px;
        }
    }

    button.couponToggle {
        flex: 1;
        display: flex;
        align-items: center;
        height: 20px;
    }

    .fauxCheckbox {
        width: 18px;
        height: 18px;
        border-radius: 3px;
        border: 1px solid ${({ theme }): string => theme.colors.borderDark};
        ${({ theme: { right } }): string => `margin-${right}: 8px`};
        position: relative;

        &.checked:after {
            content: '';
            position: absolute;
            top: 3px;
            bottom: 3px;
            left: 3px;
            right: 3px;
            border-radius: 2px;
            background-color: ${({ theme }): string => theme.colors.brandSecondary};
        }
    }

    .message {
        font-weight: bold;
    }
`;

export default FouponItemLevel;
